<template>
  <div
    class="modal fade modal-data-pack"
    ref="modalNotice"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="static"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm"
    >
      <div class="modal-content">
        <form @submit.prevent="agree">
          <div class="modal-header pb-1">
            <h5 class="text-navy-blue">Change NAP</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <!-- <p>
                  To confirm your application, we sent an OTP to your mobile
                  number. Please enter the 6-digit OTP here.
                </p> -->

                <div>
                  <div class="mb-3">
                    <label for="">Old NAP Port No.</label>
                    <input
                      class="form-control"
                      placeholder="Old NAP Port No."
                      type="text"
                      required
                      readonly
                      v-model="form.oldNapPort"
                    />
                  </div>

                  <div class="mb-3">
                    <label for="">Desire NAP Port No.</label>
                    <input
                      class="form-control"
                      placeholder="Desire NAP Port No."
                      type="text"
                      required
                      v-model="form.napPort"
                    />
                  </div>
                </div>

                <!-- <p class="mt-3">
                  Note: Unconfirmed application will not be processed
                </p> -->
              </div>
            </div>
          </div>
          <div class="modal-footer border-0">
            <button type="submit" class="btn btn-s2s-blue primary">
              <!-- <span class="spinner-border spinner-border-sm pl-5" role="status">
                <span class="visually-hidden">Loading...</span>
              </span> -->
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
    <Toast ref="toast" bgClass="bg-danger" position="top-0 end-0" />
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import Toast from "./Toast.vue";
export default {
  components: {
    Toast,
  },
  data() {
    return {
      background: "bg-f30",
      modal: null,
      resolve: null,
      reject: null,

      submitted: false,
      form: {
        oldNapPort: "",
        napPort: "",
      },
    };
  },
  methods: {
    open(data) {
      console.log("data", data);

      const { esb } = data.portReserve;

      // console.log(esb);
      this.form.oldNapPort = esb.nap_code;
      this.modal.show();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve({ status: true, data: this.form });
      // this.dialog = false;
      this.modal.hide();
    },

    cancel() {
      this.resolve({ status: false });
      // this.dialog = false;
      this.modal.hide();
    },
  },
  mounted() {
    this.modal = new Modal(this.$refs.modalNotice, {
      keyboard: false,
    });
  },

  computed: {
    isActive() {
      const sku = this.$store.getters.GET_DATAPACK;
      var def = { skuId: 0 };
      if (Object.keys(sku).length != 0) {
        return sku;
      }

      return def;
    },
  },

  created() {
    // this.getAvailableAreas();
  },
};
</script>

<style scoped>
.accordion-button {
  padding: 10px 10px;
}
</style>
